export var RETURN_BUTTON_TEXT = 'вернуться на сайт';